<template>
  <product-shipping-methods
    ref="shippingMethodsRef"
    :disabled="isOutOfStock"
    emit-invalid-selection
    @invalid-selection="handleAttributeSelection"
  />
  <panel-variant-selection :size="{ sm: 'sm', lg: 'full' }" />
</template>

<script lang="ts" setup>
const { isOutOfStock, nextAttribute, attributeSelectionFormRef } = usePdp()

const PanelVariantSelection = createPanel('variant-selection')

const shippingMethodsRef = ref()

const handleAttributeSelection = async () => {
  if (!nextAttribute.value) return
  await PanelVariantSelection.open({ attribute: nextAttribute.value, enableBopis: true })

  if (attributeSelectionFormRef.value?.validate(true)) shippingMethodsRef.value?.openStoreSearch()
}

defineExpose({
  method: computed(() => shippingMethodsRef.value?.method)
})
</script>
